import * as angular from 'angular';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { downgradeComponent } from '@angular/upgrade/static';

// Composants graphiques d'Aurora
import { MultiNumericTextInputComponent } from './components/multi-numeric-text-input.component';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
	],
	providers: [ ],
	declarations: [
		MultiNumericTextInputComponent
	],
	exports: [
		MultiNumericTextInputComponent
	],
	entryComponents: [
		MultiNumericTextInputComponent
	]
})
export class MultiTextInputModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('multiNumericTextInput',
		downgradeComponent({ component: MultiNumericTextInputComponent })
	) //
